import { mockOfficeAgent } from '../agents';
import { mockConversations } from '../conversations';
import { makeStreamStart, makeBlockStart, makeBlockEnd, makeBlockComplete, makeStreamEnd, splitTextIntoDeltas } from '../sseEvents';
const RESPONSE_ID = 'resp-conv-form';
const CONV_ID = 'conv-1';
const MD_BLOCK_ID = 'blk-cf-md';
const FORM_BLOCK_ID = 'blk-cf-form';
const markdownText = 'Sure! I can create that inspection for you. I just need a few details:';
const formBlock = {
    type: 'conversational_form',
    block_id: FORM_BLOCK_ID,
    block_index: 1,
    metadata: { thread_id: CONV_ID },
    title: 'Create New Inspection',
    description: 'Please fill in the required fields to schedule the inspection.',
    fields: [
        {
            name: 'building',
            label: 'Which building?',
            type: 'select',
            required: true,
            options: [
                { value: 'b1', label: 'Building A — 123 Main St' },
                { value: 'b2', label: 'Building B — 456 Oak Ave' },
                { value: 'b3', label: 'Building C — 789 Pine Rd' }
            ]
        },
        {
            name: 'inspection_date',
            label: 'When should the inspection be?',
            type: 'date',
            required: true,
            natural_language_hint: 'next Tuesday'
        },
        {
            name: 'inspection_type',
            label: 'Inspection type',
            type: 'radio',
            required: true,
            options: [
                { value: 'full', label: 'Full Inspection', description: 'Complete building walk-through' },
                { value: 'partial', label: 'Partial Inspection', description: 'Specific systems only' },
                { value: 'follow_up', label: 'Follow-up', description: 'Re-inspect previous deficiencies' }
            ]
        }
    ],
    show_advanced: true,
    advanced_fields: [
        {
            name: 'notes',
            label: 'Special instructions',
            type: 'textarea',
            required: false,
            placeholder: 'Any notes for the technician...'
        }
    ],
    defaults: {
        inspection_type: 'full'
    },
    submit_label: 'Create Inspection',
    cancel_label: 'Cancel',
    submit_action: {
        label: 'Create Inspection',
        action: 'query',
        params: { intent: 'create_inspection' }
    }
};
const sseSequence = [
    makeStreamStart(RESPONSE_ID, CONV_ID, mockOfficeAgent),
    makeBlockStart(MD_BLOCK_ID, 0, 'markdown'),
    ...splitTextIntoDeltas(MD_BLOCK_ID, markdownText),
    makeBlockEnd(MD_BLOCK_ID),
    makeBlockComplete(formBlock, 200),
    makeStreamEnd(RESPONSE_ID, 2, mockOfficeAgent)
];
export const scenario = {
    name: 'Office Assistant — Conversational Form',
    description: 'Office Assistant streams an intro message then delivers a conversational_form block with select, date, radio fields, and an advanced section with a textarea.',
    conversations: mockConversations,
    userMessage: 'Create an inspection for Building A',
    agentIdentity: mockOfficeAgent,
    sseSequence
};
